<template>
  <v-container fluid>
    <h3 class='d-flex justify-center subtitle'>
      {{ $t('order.list.title') }}:
    </h3>
    <v-row>
      <v-col cols='12'>
        <v-row align='center' justify='center'>
          <div
            v-for='order in orders'
            :key='order.id'
            style="width:100%;"
          >
            <ReservationCardLite
              v-for='reservation in order.reservations'
              :key='reservation.id'
              :order='order'
              :reservation='reservation'
            />
          </div>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import ReservationCardLite from '../reservations/reservation_card_lite'

  export default {
    name: 'OrdersListCards',
    components: {
      ReservationCardLite
    },
    props: {
      orders: {
        type: Array,
        required: true
      }
    }
  }
</script>
